// extracted by mini-css-extract-plugin
export var orderSummary = "_lw-0";
export var showMoreLessButton = "_lw-1";